// Static sample data for TacoSoul site.

export const MENU = [
  {
    id: "deep-fried-tacos",
    name: "OG Deep Fried Taco",
    blurb:
      "The original — crispy golden shell, slow-braised meats, the soul of Saginaw in every bite.",
    price: "$6",
    tags: ["Signature"],
    image: "/brand-images/image18.jpg",
  },
  {
    id: "fancy-chicken",
    name: "Fancy Chicken Taco",
    blurb:
      "Buttermilk-marinated chicken thigh, deep-fried, dressed with citrus crema and pickled red onion.",
    price: "$7",
    tags: ["Fan Favorite"],
    image: "/brand-images/image19.jpg",
  },
  {
    id: "carnitas",
    name: "Carnitas",
    blurb:
      "Twelve-hour braised pork, finished crispy. Cilantro, onion, charred lime. Tradition you can taste.",
    price: "$7",
    tags: ["GF Option"],
    image: "/brand-images/image12.jpg",
  },
  {
    id: "jerk-chicken",
    name: "Jerk Chicken",
    blurb:
      "Caribbean heat meets Mexican craft. Marinated in scotch bonnet, allspice, thyme. Cooled with mango pico.",
    price: "$8",
    tags: ["Spicy"],
    image: "/brand-images/image8.jpg",
  },
  {
    id: "shredded-beef",
    name: "Shredded Beef",
    blurb:
      "Red-chile braised brisket, queso fresco, a whisper of crema. Comfort food in a crispy shell.",
    price: "$8",
    tags: [],
    image: "/brand-images/image24.jpg",
  },
  {
    id: "nachos",
    name: "Loaded Nachos",
    blurb:
      "House chips, white queso, your choice of protein, fresh pico, jalapeño crema, herbs from the garden.",
    price: "$12",
    tags: ["Shareable"],
    image: "/brand-images/new-nachos.jpg",
  },
  {
    id: "loaded-fries",
    name: "Soul Loaded Fries",
    blurb:
      "Hand-cut fries, your protein, queso, scallion, crispy onion, gold sauce. Late night made right.",
    price: "$11",
    tags: [],
    image: "/brand-images/image25.jpg",
  },
  {
    id: "drinks",
    name: "House Aguas & Sodas",
    blurb:
      "Hibiscus agua fresca, horchata, Mexican Coke, Topo Chico. Cool the heat.",
    price: "$4",
    tags: [],
    image: "/brand-images/image16.jpg",
  },
];

export const FROZEN_PRODUCTS = [
  {
    id: "frozen-beef",
    name: "Ground Beef Taco",
    desc: "12-pack of our signature crispy ground beef tacos. Available in corn or flour tortilla. Freezer to plate in 12 minutes.",
    image: "/brand-images/image24.jpg",
    price: "$49",
    variants: ["Corn Tortilla", "Flour Tortilla"],
  },
  {
    id: "frozen-chicken",
    name: "Chicken Taco",
    desc: "Buttermilk-marinated chicken thigh, deep-fried & flash-frozen. Choose corn or flour. Toppings sold separately.",
    image: "/brand-images/image19.jpg",
    price: "$49",
    variants: ["Corn Tortilla", "Flour Tortilla"],
  },
  {
    id: "frozen-carnitas",
    name: "Carnitas Taco",
    desc: "Twelve-hour braised pork, crispy fried, ready in minutes. Corn or flour tortilla.",
    image: "/brand-images/image12.jpg",
    price: "$49",
    variants: ["Corn Tortilla", "Flour Tortilla"],
  },
  {
    id: "frozen-jerk",
    name: "Jerk Chicken Taco",
    desc: "Caribbean-spiced chicken, mango heat. A flavor passport. Corn or flour tortilla.",
    image: "/brand-images/image8.jpg",
    price: "$49",
    variants: ["Corn Tortilla", "Flour Tortilla"],
  },
];

export const GALLERY = [
  "/brand-images/image23.jpg",
  "/brand-images/image14.jpg",
  "/brand-images/image1.jpg",
  "/brand-images/image18.jpg",
  "/brand-images/image19.jpg",
  "/brand-images/image8.jpg",
  "/brand-images/image12.jpg",
  "/brand-images/image24.jpg",
  "/brand-images/image25.jpg",
  "/brand-images/image26.jpg",
  "/brand-images/image28.jpg",
  "/brand-images/image13.jpg",
  "/brand-images/image6.jpg",
  "/brand-images/image7.jpg",
  "/brand-images/image16.jpg",
  "/brand-images/image17.jpg",
];

export const TESTIMONIALS = [
  {
    quote:
      "I've lived in Charlotte twelve years and #TacoSoul is the most original thing to happen to our food scene. The deep-fried taco is unforgettable.",
    name: "Marcus W.",
    role: "Foodie · NoDa",
  },
  {
    quote:
      "We booked the truck for our wedding rehearsal. Guests still text me about the jerk chicken taco. Worth every penny.",
    name: "Alicia & James R.",
    role: "Married Sept 2024",
  },
  {
    quote:
      "Lebbiona brought her A-game to our employee appreciation lunch. Three hundred people. Zero complaints. Just smiles and second helpings.",
    name: "Priya N.",
    role: "HR Director · Bank of America",
  },
  {
    quote:
      "Where tacos meet soul. That's not marketing — that's exactly what it tastes like.",
    name: "Devon B.",
    role: "Charlotte Agenda",
  },
];

export const CATERING_AUDIENCES = [
  "Corporate Lunches",
  "Employee Appreciation",
  "Weddings",
  "Private Parties",
  "Festivals",
  "Schools",
  "Universities",
  "Churches",
  "Breweries",
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/story", label: "Our Story" },
  { to: "/menu", label: "Menu" },
  { to: "/order", label: "Order Online" },
  { to: "/catering", label: "Catering" },
  { to: "/book", label: "Book the Truck" },
  { to: "/shop", label: "Frozen Shop" },
  { to: "/schedule", label: "Schedule" },
  { to: "/franchise", label: "Franchise" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact" },
];

export const CONTACT = {
  email: "Hashtag.TacoSoul@gmail.com",
  city: "Charlotte, NC",
  instagram: "https://instagram.com",
  facebook: "https://facebook.com",
  tiktok: "https://tiktok.com",
};

// Square Online store — paste public URL here when ready. Leave empty to keep
// products in "Coming Soon / Waitlist" mode.
export const SQUARE_STORE_URL = "";

// DoorDash store URL — paste when listed.
export const DOORDASH_URL = "";
export const UBEREATS_URL = "";
export const GRUBHUB_URL = "";
